<template>
  <div class="top-header-container">
    <img
      class="logo largeLogo"
      src="/images/dark-logo.svg"
      alt="Leland Little Auctions"
      @click="exit"
    >
    <label>AUCTION ITEM CHECKOUT</label>
  </div>
</template>

<script>
export default {
  name: "TopHeaderComponent",
  props: ["exit"],
};
</script>